import { Button } from '../Button';
import PremiumIcon from '../PremiumIcon';

export default function GenerateLinksButton({
  isSignedIn,
  handleclickTopup,
}: {
  isSignedIn: boolean;
  handleclickTopup: () => void;
}) {
  return (
    <div className="flex flex-col items-center justify-center">
      <div className="my-2 flex items-center">
        <div className="w-full border-b border-gray-400"></div>
        <span className="mx-2 text-xs text-gray-500">or</span>
        <div className="w-full border-b border-gray-400"></div>
      </div>

      <Button
        className="inline-block rounded border border-[#FFE2B4] bg-[#FFCA63] px-8 py-3 text-sm font-medium text-white hover:bg-[#FFCA63]/80 focus:outline-none active:bg-[#FFCA63] disabled:cursor-not-allowed disabled:bg-[#FFCA63] disabled:text-white disabled:opacity-60 disabled:hover:border-[#FFE2B4]"
        disabled={!isSignedIn}
        type="button"
        onClick={handleclickTopup}
      >
        <span className="text-md flex justify-center font-bold">
          Top up to get Links & References
          <PremiumIcon className="ml-2 inline h-5 fill-white" />
        </span>
      </Button>
    </div>
  );
}
